import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const deleteUserRfid: UseCase<UserRepository, 'deleteUserRfid'> = repository => {
  return async (rfidUpdate) => {
    await repository.deleteUserRfid(rfidUpdate)
  }
}
